import React from "react"
import bgButton from "./assets/bg-button.svg"
import bgButtonBlack from "./assets/bg-button-black.svg"
import { twMerge } from "tailwind-merge"

type ButtonTheme = "black" | "white"

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  theme?: ButtonTheme
  className?: string
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ theme = "white", className, children, ...props }, ref) => {
    const backgroundImage = theme === "black" ? bgButtonBlack : bgButton
    const textColor = theme === "black" ? "text-white" : "text-black"

    return (
      <button
        ref={ref}
        {...props}
        className={twMerge(
          "w-full h-[60px]",
          "bg-no-repeat bg-[length:100%_100%]",
          "inline-flex items-center justify-center text-center uppercase",
          "font-sans-bold font-bold tracking-[0.5px]",
          "text-[14px] leading-[18px]",
          "transition-opacity hover:opacity-90",
          "disabled:opacity-80 disabled:cursor-not-allowed",
          textColor,
          className,
        )}
        style={{
          backgroundImage: `url(${backgroundImage})`,
          ...(props.style || {}),
        }}
      >
        {children}
      </button>
    )
  },
)

Button.displayName = "Button"
